import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';
import { ControlDataForm } from './control-data-form';

export class ControlDataExportFile extends ModelBase {
  forms: ControlDataForm[];
  sentToTaxAuthorityAt: Date;
  voidedAt: Date;
  createdAt: Date;
  caption: string;
  comment: string;
}
